import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';

const ArchiveORTModal = ({ openForm, openSpravka }) => {
	const [modalData, setModalData] = useState([])
	const [baseData, setBaseData] = useState([])
	const [isSave, setIsSave] = useState(false)
	const [refusal, setRefusal] = useState(false)
	const [osnovanieName, setOsnovanieName] = useState([]);
	const [updateNaz, setUpdateNaz] = useState({
		naznachenie_kg: '',
		naznachenie: '',
		naznachenie_en: '',

	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})



	const { t, i18n } = useTranslation()



	const openInput = () => {
		setRefusal(!refusal)
	}

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
	  PaperProps: {
		style: {
		  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,			
		  width: 250,
		},
	  },
	};

	// const getReports = async id => {
	// 	const a = await http.post('/report/reportApplicationWait?reportType=' + id)
	// 	report.newReport(a.data.reportApplicationWait)
	// }

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		setModalData(res.data.data)
		setUpdateNaz({ 
			naznachenie_kg: res.data.data.naznachenie_kg, 
			naznachenie: res.data.data.naznachenie,
			naznachenie_en:res.data.data.naznachenie_en, 
		})
		setOsnovanieName(res.data.data.osnovanii.split(",").map(Number))
	}

	const getArchiveORTModaldata = async () => {
		const res = await http.post('/okno/archiveORTModaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		setBaseData(res.data.data[0])
	}
	console.log('baseData', baseData)
	
	// процедура на модального окно для сохранения данных в справках
	const updateModalDate = async () => {

		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			osnovanii: osnovanieName,
			naznachenie_kg: updateNaz.naznachenie_kg,
			naznachenie: updateNaz.naznachenie,
			naznachenie_en:updateNaz.naznachenie_en,
			raion_kg: null,
			work: null
		})
		if (res.data.result !== null) {
			toast(res.data.result)
		}
		setIsSave(false)
		// console.log("update Embass", res);
	}


	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			// getReports(0)
			openForm()
			// setIsSave(false)
		}
		// console.log("update", res);
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'
		return () => (document.body.style.overflowY = 'visible')
	}, [])

	// React.useEffect(() => {
	// 	getReports(0)
	// }, [])

	React.useEffect(() => {
		if (openForm) {
			getModaldata()
			getArchiveORTModaldata()
		}
	}, [])

	const change = e => {
		const { name, value } = e.target
		setUpdateNaz({ ...updateNaz, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}


	
	  const handleChange = (event) => {
		const { value } = event.target;
		setOsnovanieName(value)
		setIsSave(true)
	  };


	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}
	
	
	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateNaz.naznachenie?.length >= 4 ? (
								<a
									className='new_report'
									target='_blank'
									href={`/bt/api/r/ar-e-ort?idzakaz=${student.student.id_okno_zakaz}&idf=${student.student.id_faculty}&gid=${student.student.id_group}&id=${student.student.id_student}&lang=${i18n.language}`}
								>
									<button className={styles.button_modal} onClick={openForm}>
										Просмотр
									</button>
								</a>
							) : null} 
						</div>
					) : (
						<div></div>
					)}
				</div>
				
				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Студент:</span>
								<p>{modalData?.fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData.reference_number}</p>
							</div>
						</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Основание:</span>
								<FormControl sx={{ width: 370 }}>
									<InputLabel id="demo-multiple-checkbox-label" style={{marginTop: '-10px'}}>Выбрать основание.</InputLabel>
									<Select 
										style={{border: "1px solid #02a4ea"}}
										sx={{ height: 30 }}
										labelId="demo-multiple-checkbox-label"
										id="demo-multiple-checkbox"
										multiple
										value={osnovanieName}
										onChange={handleChange}
										input={<OutlinedInput label="Tag" />}
										renderValue={(selected) =>
											baseData
											  .filter((base) => selected.includes(base.id_okno_osnovanie))
											  .map((filteredName) => filteredName.osnovanie)
											  .join(", ")
										  }
										MenuProps={MenuProps}
										>
										{baseData?.map((name) => (
											<MenuItem key={name?.id_okno_osnovanie} value={name?.id_okno_osnovanie} style={{zIndex: '9999999'}}>
											<Checkbox checked={osnovanieName.includes(name?.id_okno_osnovanie)}/>
											<ListItemText primary={name?.osnovanie} />
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Максаты:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='naznachenie_kg'
									value={updateNaz.naznachenie_kg}
									onChange={change}
								>
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Назначение:</span>
								<input
									className={styles.input_modal}
									onChange={change}
									type='text'
									name='naznachenie'
									value={updateNaz.naznachenie}
								>
								</input>
							</div>
								<div className={styles.input_block}>
								<span className={styles.name_student_text}>Appointment:</span>
								<input
									className={styles.input_modal}
									onChange={change}
									type='text'
									name='naznachenie_en'
									value={updateNaz.naznachenie_en}
								>
								</input>
							</div>
						</div>

						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div className={styles.modal_window_data}>
						<div className={styles.input_block}>
							<span className={styles.name_student_text}>Причина отказа:</span>
							<input
								className={styles.input_modal}
								type='text'
								placeholder='Введите причину отказа...'
								name='rejected_komment'
								value={reasonRefusal.rejected_komment}
								onChange={changeRefusal}
							>
								{/* Причина отказа */}
							</input>
						</div>
					</div>
				)}

				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 4 ? (
									<button onClick={postReasonRefusal} className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateNaz.naznachenie?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default ArchiveORTModal
